import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Courses from './pages/Courses';
import Books from './pages/Books';
import VideosInDari from './pages/VideosInDari';
import Videos from './pages/Videos';
import PlayList from './pages/PlayList';
import { motion } from 'framer-motion';
import './index.css';
// import './mystyles1.css';

function MainContent() {
  return (
    <>
      <h1 style={{ color: 'red' }}>HMR test</h1>
      <h1 style={{ color: 'red' }}>CHANGED at {new Date().toLocaleTimeString()}</h1>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="pt-20 min-h-screen"
      >
        <iframe
          className="w-full aspect-video rounded-lg shadow-lg"
          src="https://www.mywebuniversity.com/index1w.html"
          title="MyWebUniversity"
          frameBorder="0"
          allowFullScreen
        />
      </motion.div>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/books" element={<Books />} />
        <Route path="/videosindari" element={<VideosInDari />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/playlist" element={<PlayList />} />
        {/* Show custom content for unknown paths */}
        <Route path="*" element={<MainContent />} />
      </Routes>
    </Router>
  );
}
